import AccountList from "src/features/accounts/AccountList";

const AccountListScreen = () => {
    return <AccountList />
}

AccountListScreen.guestGuard = false;
AccountListScreen.authGuard = true;

export { AccountListScreen }
export default AccountListScreen;